import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { IoArrowUp } from "react-icons/io5";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  // Don't show button on landing page
  const isLandingPage = location.pathname === "/";

  // Handle scroll event to show/hide the button
  useEffect(() => {
    const toggleVisibility = () => {
      // Show button after scrolling down 300px
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    // Clean up the event listener
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Don't render anything on landing page
  if (isLandingPage) return null;

  return (
    <button
      onClick={scrollToTop}
      style={{
        position: "fixed",
        bottom: "30px",
        right: "30px",
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        color: "white",
        border: "none",
        cursor: "pointer",
        display: isVisible ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        transition: "all 0.3s ease-in-out",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.9)";
        e.currentTarget.style.transform = "translateY(-3px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <IoArrowUp size={24} />
    </button>
  );
};

export default ScrollToTopButton;
